import { get, set } from "@ember/object"
import Mixin from "@ember/object/mixin"
import { later, scheduleOnce } from "@ember/runloop"

export default Mixin.create({
  didRender() {
    this._super(...arguments)
    let inClass = get(this, "animateInClass") || "fadeInDown"
    let outClass = get(this, "animateOutClass") || "bounceOutDown"
    if (get(this, "state.isOpen") === true) {
      scheduleOnce("afterRender", () => {
        if (this.isDestroyed || this.isDestroying) return
        set(this, "hasOpened", true)
        set(this, "hasOpenedClasses", "animated animated-fast " + inClass)
        set(this, "overlayClasses", "animated animated-fast fadeIn")
      })
    } else {
      if (get(this, "hasOpened") !== true) return
      scheduleOnce("afterRender", () => {
        if (this.isDestroyed || this.isDestroying) return
        set(this, "hasOpenedClasses", "animated " + outClass)
      })
      later(() => {
        if (this.isDestroyed || this.isDestroying) return
        set(this, "overlayClasses", "animated animated-fast modalFadeOut")
      }, 250)
      later(() => {
        if (this.isDestroyed || this.isDestroying) return
        set(this, "hasOpened", false)
      }, 750)
    }
  },
})
